import React from 'react';
import { Pill } from '@gpstrackit/gtc-react-controls';

const SeverityBadge = ({ isCritical }) => {
  return (
    <Pill
      item={{
        label: isCritical ? 'Critical' : 'Non-Critical',
        color: isCritical ? '#d32f2f' : '#ed6c02',
      }}
      variant="outlined"
      style={{ fontWeight: 500, fontSize: '12px', cursor: 'unset !important' }}
      clickable={false}
    />
  );
};

export default SeverityBadge;
